import React from 'react';
import cx from 'classnames';
import styles from './table.module.scss';
import { ITable } from './table.model';

import TableHeader from './table-header';
import TableRow from './table-row';
import TableCell from './table-cell';
import TableBody from './table-body';
import TableHeaderCell from './table-header-cell';

const Table = (props: ITable) => {
  const { children, className } = props;

  const classNames = cx(styles.table, className);

  return (
    <div className={classNames}>
      <table>{children}</table>
    </div>
  );
};

export default Table;

Table.Header = TableHeader;
Table.HeaderCell = TableHeaderCell;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
